<div class="container flex-column full-height full-width" vdwBp.gt-xs="flex-center gap-24" vdwBp.lt-sm="flex-start-center gap-48">
  <app-connect-baseline class="baseline-visual"></app-connect-baseline>
  <div class="flex-column flex-center text-align-center" vdwBp.gt-xs="flex-center gap-8" vdwBp.lt-sm="flex-start-center gap-24">
    <span class="main-title" [innerHTML]="'GENERAL.ERRORS.STATUSCODE.NOT_FOUND.MAIN_TITLE' | bmsTranslate"></span>
    <span class="subtitle">{{ 'GENERAL.ERRORS.STATUSCODE.NOT_FOUND.SUB_TITLE' | bmsTranslate }}</span>
  </div>
</div>
